import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import glamorous from "glamorous";
import { Fixed, Flex, Layout } from "react-layout-pane";
import Link from "redux-first-router-link";
import { BooleanValue } from "react-values";

import { fetchDomainData } from "./modules/domain-data/DomainDataState";
import { fetchLocations } from "./modules/locations/LocationsState";
import { fetchOrganizations } from "./modules/organizations/OrganizationsState";
import { fetchRoles } from "./modules/roles/RolesState";
import ShipmentSearchState from "./modules/shipment-search/ShipmentSearchState";

import HeaderBar from "./modules/header-bar/HeaderBarView";
import AppNavView from "./modules/appnav/AppNavView";
import { mainComponentForLocation, navigationForLocation } from "./routes";
import Colors from "./styles/colors";
import LadsState from "./modules/lads/LadsState";
import { initHere } from "./modules/map/MapState";
import Authentication from "./modules/auth/authentication";
import Account from "react-icons/lib/md/account-circle";
import { FlexDiv, FlexColDiv } from "./styles/container-elements";
import LinkButton from "./vendor/signal-widgets/components/link-button";

import "./styles/App.css";

const authentication = new Authentication();

const SidebarFooter = ({ auth, sidebarMinimize }) => {
  let userName = "";
  if (auth.isAuthenticated()) {
    const itoken = auth.getDecodedIdToken();
    userName = itoken["nickname"];
  }

  return (
    <FlexDiv
      css={{
        padding: "1em"
      }}
    >
      <FlexColDiv css={{ alignItems: "center", justifyContent: "center" }}>
        <Link to={{ type: "PROFILE" }}>
          <glamorous.Span
            css={{
              color: "#acb5be",
              paddingLeft: ".75em",
              ":hover": {
                color: Colors.bannerLinkText,
                cursor: "pointer",
                textDecoration: "none"
              }
            }}
          >
            <Account style={{ height: "1.75em", width: "1.75em" }} />
          </glamorous.Span>
        </Link>
      </FlexColDiv>
      {!sidebarMinimize ? (
        <FlexColDiv css={{ marginLeft: ".5em" }}>
          <FlexDiv>
            <glamorous.Span style={{ fontSize: "1em" }}>
              {userName}
            </glamorous.Span>
          </FlexDiv>
          <FlexDiv>
            <LinkButton
              style={{
                color: Colors.linkText,
                fontSize: ".75em",
                textDecoration: "none",
                ":hover": {
                  color: Colors.bannerLinkText,
                  cursor: "pointer",
                  textDecoration: "none"
                }
              }}
              onClick={() => auth.logout()}
            >
              Log Out
            </LinkButton>
          </FlexDiv>
        </FlexColDiv>
      ) : null}
    </FlexDiv>
  );
};

const SideBar = ({ auth, location }) => {
  let currentLocation = location.type || "";
  return (
    <BooleanValue>
      {({ value, toggle }) => (
        <Fixed
          className="sidebar"
          style={{
            color: "#acb5be",
            backgroundColor: Colors.background.GRAY_BLUE,
            width: value ? "4.5em" : "19em"
          }}
        >
          <Layout type="column">
            <Fixed>
              <AppNavView
                currentLocation={currentLocation}
                sidebarMinimize={value}
                toggle={toggle}
              />
            </Fixed>
            <Flex />
            <Fixed className="sidebar-footer">
              <SidebarFooter auth={auth} sidebarMinimize={value} />
            </Fixed>
          </Layout>
        </Fixed>
      )}
    </BooleanValue>
  );
};

class App extends Component {
  reloadDomainData() {
    const { dispatch } = this.props;

    // Always dispatch these methods, we cannot get
    // here unless we have made it pass the auth interceptor
    dispatch(fetchDomainData());
    dispatch(fetchLocations());
    dispatch(fetchOrganizations());
    dispatch(fetchRoles());
    dispatch(LadsState.actionCreators.fetchLads());
  }

  componentDidMount() {
    const { dispatch } = this.props;

    this.reloadDomainData();
    dispatch(initHere(window.H));
  }

  componentWillReceiveProps(nextProps) {
    const { currentUser, currentOrg, dispatch } = this.props;
    if (nextProps.currentUser !== currentUser) {
    }

    if (currentOrg != null && currentOrg !== nextProps.currentOrg) {
      // Reload domain data for the new organization and return to the root screen
      this.reloadDomainData();
      dispatch({ type: "ROOT" });
      dispatch(ShipmentSearchState.actionCreators.resetSearch());
    }
  }

  isErrorView(location) {
    const { type } = location;
    return (
      type &&
      (type === "VERIFY_USER_ERROR" || type === "ACCESS_FORBIDDEN_ERROR")
    );
  }

  render() {
    const { location, organizations, auth } = this.props;

    // if not a shipper make sure user does not have access to locations
    const currentOrganizationId = sessionStorage.getItem("currentOrganization");
    const organization = _.find(organizations, {
      organization_id: Number(currentOrganizationId)
    });
    const isShipper = organization
      ? organization.org_type === "Shipper" ||
        organization.org_type === "FreightVerify"
      : false;
    if (
      !isShipper &&
      (location.pathname === "/locations" ||
        location.pathname === "/locationmanagement")
    ) {
      location.pathname = "/accessForbiddenError";
      location.type = "ACCESS_FORBIDDEN_ERROR";
    }

    const mainComponent = mainComponentForLocation(location);
    const appnavComponent =
      navigationForLocation(location) &&
      authentication.isAuthenticated() &&
      !this.isErrorView(location) ? (
        <SideBar location={location} auth={auth} />
      ) : null;

    const headerComponent =
      navigationForLocation(location) && authentication.isAuthenticated() ? (
        <HeaderBar location={location} />
      ) : null;

    return (
      <Layout className="app" type="row">
        {appnavComponent}
        <Flex>
          <Layout type="column">
            <Fixed
              className="headerbar"
              style={{ backgroundColor: Colors.background.LIGHT_GRAY }}
            >
              {headerComponent}
            </Fixed>
            <Flex
              className="maincontent"
              style={{ backgroundColor: Colors.background.LIGHT_GRAY }}
            >
              {mainComponent}
            </Flex>
          </Layout>
        </Flex>
      </Layout>
    );
  }
}

function mapStateToProps(state) {
  return {
    location: state.location,
    auth: state.users.auth,
    currentUser: state.users.currentUser,
    currentOrg: state.organizations.currentOrganizationId,
    organizations: state.organizations.data
      ? state.organizations.data.response
      : state.organizations.data
  };
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js